/** 需要 RTL 镜像的语言（阿拉伯语等） */
export const RTL_LOCALES = ["ar"];

export function isRtlLocale(locale: string | undefined): boolean {
  if (!locale) return false;
  const code = locale === "zh-CN" ? "cn" : locale === "zh-HK" ? "hk" : locale;
  return RTL_LOCALES.includes(code);
}
